// @ts-nocheck
import * as React from "react";

const ExternalLink: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M5.615 20c-.46 0-.844-.154-1.152-.462A1.565 1.565 0 0 1 4 18.384V5.616c0-.46.154-.845.463-1.153A1.565 1.565 0 0 1 5.615 4h12.77c.46 0 .844.154 1.152.463.309.308.463.692.463 1.152v6h-1v-6a.588.588 0 0 0-.192-.423.588.588 0 0 0-.424-.192H5.616a.588.588 0 0 0-.424.192.588.588 0 0 0-.192.423v12.77c0 .153.064.295.192.423s.27.192.423.192h6v1h-6ZM14 20v-1h4.311L9.088 9.777l.689-.688L19 18.285V14h1v6h-6Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(ExternalLink);
